import { render, staticRenderFns } from "./modalSolicitarNovaAmostraCheckPoint.vue?vue&type=template&id=77fe3252&"
import script from "./modalSolicitarNovaAmostraCheckPoint.vue?vue&type=script&lang=js&"
export * from "./modalSolicitarNovaAmostraCheckPoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports